import { render } from "./IncrementDecrement.vue?vue&type=template&id=37e1469f&scoped=true"
import script from "./IncrementDecrement.vue?vue&type=script&lang=js"
export * from "./IncrementDecrement.vue?vue&type=script&lang=js"

import "./IncrementDecrement.vue?vue&type=style&index=0&id=37e1469f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37e1469f"

export default script